import * as React from "react";
import { useMemo } from "react";
import * as Immutable from "immutable";
import useFieldTypes from "views/logic/fieldtypes/useFieldTypes";
import { filtersToStreamSet } from "views/logic/queries/Query";
import useCurrentQuery from "views/logic/queries/useCurrentQuery";
import useOnSearchExecution from "views/hooks/useOnSearchExecution";
import FieldTypesContext from "./FieldTypesContext";
const defaultTimeRange = { type: "relative", from: 300 };
const DefaultFieldTypesProvider = ({ children }) => {
  const currentQuery = useCurrentQuery();
  const currentStreams = useMemo(() => filtersToStreamSet(currentQuery == null ? void 0 : currentQuery.filter).toArray(), [currentQuery == null ? void 0 : currentQuery.filter]);
  const { data: currentFieldTypes, refetch: refreshCurrentTypes } = useFieldTypes(
    currentStreams,
    (currentQuery == null ? void 0 : currentQuery.timerange) || defaultTimeRange
  );
  const { data: allFieldTypes, refetch: refreshAllTypes } = useFieldTypes(
    [],
    (currentQuery == null ? void 0 : currentQuery.timerange) || defaultTimeRange
  );
  const all = useMemo(() => Immutable.List(allFieldTypes != null ? allFieldTypes : []), [allFieldTypes]);
  const fieldTypes = useMemo(
    () => ({ all, currentQuery: Immutable.List(currentFieldTypes) }),
    [all, currentFieldTypes]
  );
  useOnSearchExecution(() => {
    refreshCurrentTypes();
    refreshAllTypes();
  });
  return /* @__PURE__ */ React.createElement(FieldTypesContext.Provider, { value: fieldTypes }, children);
};
export default DefaultFieldTypesProvider;
